import React from "react";
import secpCertificate from "../../assets/img/certificates/secp.webp";
import pecCertificate from "../../assets/img/certificates/pec.webp";
import iso9001Certificate from "../../assets/img/certificates/iso9001.webp";
import iso14001Certificate from "../../assets/img/certificates/iso14001.webp";
import fbrAmlCertificate from "../../assets/img/certificates/fbr-amlcft.webp";

const certificates = [
  {
    id: "secp",
    src: secpCertificate,
    title: "SECP Certificate",
    subtitle: "Official registration documentation presented as part of our company compliance credentials.",
  },
  {
    id: "pec",
    src: pecCertificate,
    title: "PEC Certificate",
    subtitle: "Professional certification that supports our work with regulated business and engineering-related registrations.",
  },
  {
    id: "iso9001",
    src: iso9001Certificate,
    title: "ISO 9001:2015",
    subtitle: "Quality Management System certification held by our client organizations, reflecting consistent, well-managed processes.",
  },
  {
    id: "iso14001",
    src: iso14001Certificate,
    title: "ISO 14001:2015",
    subtitle: "Environmental Management System certification covering construction, MEP, and related project work.",
  },
  {
    id: "fbr-amlcft",
    src: fbrAmlCertificate,
    title: "FBR AML/CFT Registration",
    subtitle: "Registered with the Directorate General of DNFBPs, FBR, for AML/CFT compliance under the Anti Money Laundering Act, 2010.",
  },
];

export const HomeCertificatesSection = () => {
  return (
    <section className="home-certificates-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-50 tg-heading-subheading animation-style2">
              <span className="sub-title tg-element-title">Our Certificates</span>
              <h2 className="title tg-element-title">
                Certifications that support our consultancy work
              </h2>
              <p>
                We maintain formal credentials that reflect our professional
                standing and commitment to compliant business consultancy
                services.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4">
          {certificates.map((certificate) => (
            <div key={certificate.id} className="col-lg-4 col-md-6">
              <div className="home-certificate-card">
                <div className="home-certificate-image">
                  <img src={certificate.src} alt={certificate.title} />
                </div>
                <div className="home-certificate-content">
                  <h3>{certificate.title}</h3>
                  <p>{certificate.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
